import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import TepezzaWrapper from "@components/layouts/tepezzaWrapper";
import MainBanner from "@components/tepezza/mainBanner";

const OffersList = dynamic(() => import("@components/shared/offersList"));
const Lawsuits = dynamic(() => import("@components/tepezza/lawsuits"));

const SideEffects = dynamic(() => import("@components/tepezza/sideEffects"));

export default function MedicalSoftwareHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <TepezzaWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Lawsuits />

            <SideEffects />
        </TepezzaWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
